module.exports = __webpack_public_path__ + "static/media/EyeCrossed_Icon.cc03ffcf.png";